import Action from "./action";
import Prune from "./prune";
import {ActionTypeEnum, TriggerTypeEnum} from "./training-literals";
import LoadEvents from "./load-events";

export default class LoadTimeline extends Action {
    timelines;
    triggerType;
    prune;

    constructor(props) {
        super(props);
        this.timelines = props.timelines || [];
        this.events = props.events || [];
        this.triggerType = props.triggerType ?? TriggerTypeEnum.TIMELINE;
        this.prune = new Prune(props.prune || {});
        this.preserveActionList = props.preserveActionList || [ActionTypeEnum.STEP_INSTRUCTION_MENU];
    }

    async execute(eventLoop) {
        if (this.triggerType === TriggerTypeEnum.EVENT && this.events && this.events.length > 0) {
            const loadEvents = new LoadEvents({events: this.events});
            await loadEvents.execute(eventLoop);
            return;
        }

        let timelineIds = [];
        let timelineNames = [];
        let hasPreserveAction = false;
        let hasStepMenuFrame = false;

        for (let timeline of this.timelines) {
            const result = await Action.parseValue(timeline, eventLoop);
            if (!result) continue;

            const timelineToBeLoaded = eventLoop.training.timelines[result];
            timelineIds.push(result);
            timelineNames.push(timelineToBeLoaded.name);

            if (!hasPreserveAction) {
                hasPreserveAction = timelineToBeLoaded.actionSequence.some(
                    action => this.preserveActionList.includes(action.type) && action.properties.startTime === 0
                );
            }

            if (!hasStepMenuFrame && hasPreserveAction) {
                const loadStateAction = timelineToBeLoaded.actionSequence.find(
                    action => (action.type === ActionTypeEnum.LOAD_STATE) && action.startTime === 0
                );

                hasStepMenuFrame = eventLoop.training.states[loadStateAction?.states[0]]?.__actionStates?.stepMenuFrame;
                const stepMenuAction = eventLoop.runningActions.find(action => action.type === "StepInstructionMenu");
                if (hasStepMenuFrame && stepMenuAction) {
                    hasStepMenuFrame = stepMenuAction.instructionMenuController.parent !== stepMenuAction.instructionMenuController.getParent(hasStepMenuFrame);
                }
            }
        }

        if (hasPreserveAction && !hasStepMenuFrame) {
            eventLoop.runningActions.forEach(action => {
                if (this.preserveActionList.includes(action.type)) {
                    action.previousClassName = action.className;
                    action.className = action.type;
                }
            });
        }

        await this.prune.execute(eventLoop);

        console.log('load timeline', timelineNames);
        eventLoop.addTimelines(timelineIds);
    }
}

